import React, { useEffect } from 'react';

const useOnClickOutside = <T extends HTMLElement>(
  ref: React.MutableRefObject<T | null>,
  handler: () => void,
  ignoredIds?: Array<string>
): void => {
  useEffect(
    () => {
      const ignoreId = (event : MouseEvent) : boolean => {
        if(!ignoredIds) return false;
        if(ignoredIds.length === 0) return false;

        const id = (event.target as HTMLInputElement).id;
        return ignoredIds.some(x => id.includes(x));
      };

      const handleClick = (event: MouseEvent): void => {
        if (!ref.current ||
            ref.current?.contains(event.target as Node) ||
            ignoreId(event)) {
          return;
        }

        handler();
      };
      document.addEventListener('click', handleClick);
      return (): void => {
        document.removeEventListener('click', handleClick);
      };
    },
    [ref, handler]
  );
};

export default useOnClickOutside;
